import React, { useEffect, useState } from 'react';
import InvoiceTable from '../../pages/InvoiceTable';
import { useLocation, useParams } from 'react-router-dom';
import { API_ROOT } from '../../service/Services';
import axios from 'axios';

export const InvoiceView = () => {
  const location = useLocation();
  const invoice = location?.state || {};




  return <InvoiceTable data={invoice} company={invoice?.companyDetails} />;
};
